import React from 'react';
import styled, { keyframes } from 'styled-components';
import { responsive } from '../resources/constantes.json';

const BarraProgreso = ({
  porcentaje,
  className = '',
  color,
  cual,
  margin,
  height = '12px',
  umbral,
}) => {
  return (
    <div className={'barra-progreso ' + className}>
      <div className="barra-progreso_background-barra">
        <Bar
          className="barra-progreso_barra"
          porcentaje={porcentaje.replace(',', '.')}
          bar={cual}
          height={height}
          umbral={umbral}
          style={{
            backgroundColor: color ? color : '',
            marginLeft: margin ? margin + '%' : '',
          }}
        />
      </div>
    </div>
  );
};

// prettier-ignore
const BarraProgresoStyled = styled(({ height, umbral = '30%', ...rest }) => (
  <BarraProgreso height={height} umbral={umbral} {...rest} />
))`
  position: relative;
  width: 100%;
  height: ${({ height }) => height ?? '12px'};
  .barra-progreso_background-barra {
    background-color: #d8d8da;
    border-radius: 10px;
    height: ${({ height }) => height ?? '12px'};
    @media screen and (max-width: ${responsive.mobile}px) {
      width: ${({ maxWidth }) => maxWidth ?? '50vw'};
    }
  }
  
  &::after {
    content: '${({ umbral }) => { return umbral ? 'Umbral segunda vuelta  ' + umbral : ''}}';
    position: absolute;
    top: -110%;
    left: ${({ umbral }) => umbral?.replace?.(",",".") ?? '10%'};
    transform: translateX(-50%);
    font-weight: bold;
    min-width: 20ch;
    line-height: 4.8rem;
  }

    &::before {
      content: '';
      position: absolute;
      left:  ${({ umbral }) => umbral?.replace?.(",",".") ?? '10%'};
      top: 0;
      display:  ${({ umbral }) => (umbral ? 'initial' : 'none')};
      bottom: 0;
      width: 2px;
      background-color: #164192;
      z-index: 1;
    }
 
`;

const fill = keyframes`
  from {
    width:0%;
  }
  to {
    width:${({ porcentaje }) => porcentaje};
  }
`;

const Bar = styled(({ porcentaje, bar, height, ...rest }) => <div {...rest} />)`
  height: ${({ height }) => height ?? '12px'};
  border-radius: 5px;
  animation: ${fill} 2s linear;
  width: ${({ porcentaje }) => porcentaje};
  position: relative;
`;

export default BarraProgresoStyled;
